import './HiveOverlay.css';
export var overlay = '_13hmp1l0-2-0-1';